"use strict";
exports.__esModule = true;
exports.assignDdaResponse = void 0;
exports.assignDdaResponse = {
    dda_payment_method_public_id: '1231231-123123-123123'
};
